import React from 'react';
import { PERIOD_FILTERS } from '../../../core/constants/financial';

// Barra de filtro de período reutilizada pelas listagens financeiras
// (Contas a Pagar/Receber, Caixa do período, Lançamentos). Chips de período
// + inputs de range custom quando 'Selecionar Período'.
const PeriodFilter = ({ filter, onFilterChange, customRange, onCustomRangeChange }) => (
  <div className="fd-period-filters">
    <span className="fd-period-filters-label">Período:</span>
    {PERIOD_FILTERS.map((p) => (
      <button
        key={p.key}
        type="button"
        className={`fd-period-btn ${filter === p.key ? 'fd-period-btn--active' : ''}`}
        onClick={() => onFilterChange(p.key)}
      >
        {p.label}
      </button>
    ))}
    {filter === 'periodo' && (
      <div className="fd-period-range">
        <input
          type="date"
          className="fd-installment-input"
          value={customRange.from || ''}
          onChange={(e) => onCustomRangeChange({ ...customRange, from: e.target.value })}
        />
        <span style={{ color: '#999', fontSize: 11 }}>até</span>
        <input
          type="date"
          className="fd-installment-input"
          value={customRange.to || ''}
          onChange={(e) => onCustomRangeChange({ ...customRange, to: e.target.value })}
        />
      </div>
    )}
  </div>
);

export default PeriodFilter;
